<sd-header></sd-header>

<ng-container [ngSwitch]="state.step">
	<sd-landing *ngSwitchCase="'landing'"></sd-landing>
	<sd-account *ngSwitchCase="'login'"></sd-account>
	<sd-expanded-access *ngSwitchCase="'painted'"></sd-expanded-access>
	<sd-apps-home *ngSwitchDefault></sd-apps-home>
</ng-container>

<sd-feedback-widget></sd-feedback-widget>
